import { observer } from 'mobx-react-lite';
import { FC, useEffect, useState } from 'react';
import { useStore } from '../../../hooks/useStore';
import { Loading } from '../../../lib/components';
import { CardWidget } from '../../../lib/components/compound/surfaces/cardWidget';
import Util from '../../../misc/util';
import { EmployeeDashboardListItem } from '../shared/employeeListItem';
import { ScrollableList } from '../shared/scrollableList';
import { EmployeeListItem } from '@pxtra-client-lib-legacy/gen';
import { useTranslation } from 'react-i18next';

export const BirthdaysDashboardWidget: FC = observer(() => {
  const { employeeStore, companyStore } = useStore();
  const [sortedBirthdayEmployees, setSortedBirthdayEmployees] = useState<EmployeeListItem[]>();
  const { t } = useTranslation();

  const getSortedBirthdayEmployees = async () => {
    const employees = await employeeStore.fetchList([
      'birth_date',
      'first_name',
      'id',
      'last_name',
      'position_name',
      'profile_picture',
      'status'
    ]);
    setSortedBirthdayEmployees(
      employees
        ?.slice()
        .filter(
          (e) =>
            e.birth_date &&
            e.status !== 'RESIGNED' &&
            e.status !== 'INACTIVE' &&
            e.status !== 'DEACTIVATION_DELAYED'
        )
        .sort((prev, curr) => {
          const prevDate =
            (prev?.birth_date && Util.calcNextYearlyDateMilliseconds(prev.birth_date)) || 0;
          const currDate =
            (curr?.birth_date && Util.calcNextYearlyDateMilliseconds(curr.birth_date)) || 0;

          return currDate && prevDate && prevDate - currDate;
        })
        .slice(0, 5)
    );
  };

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!companyStore.company) return;
    const abortController = new AbortController();
    const fetch = async () => {
      try {
        setIsLoading(true);
        await getSortedBirthdayEmployees();
        setIsLoading(false);
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error(error);
        }
      }
    };

    fetch();
    return () => abortController.abort();
  }, [companyStore.company]);

  return (
    <CardWidget title={t('common:BIRTHDAY_other')} subTitle={t('common:BIRTHDAY_SUBTITLE')}>
      {isLoading ? (
        <Loading />
      ) : (
        <ScrollableList>
          {sortedBirthdayEmployees &&
            sortedBirthdayEmployees.map((employee, index) => {
              return (
                <EmployeeDashboardListItem
                  key={index}
                  id={employee.id}
                  first_name={employee.first_name}
                  last_name={employee.last_name}
                  profile_picture={employee.profile_picture}
                  birth_date={employee.birth_date}
                  position_name={employee.position_name}
                />
              );
            })}
        </ScrollableList>
      )}
    </CardWidget>
  );
});
